<div class="table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table custom-table">

        <!-- Dynamic Columns -->
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.key">
            <th mat-header-cell *matHeaderCellDef>{{ column.label}} <br /> <small>{{column.sublabel}}</small></th>
            <td mat-cell *matCellDef="let element" [innerHTML]="element[column.key]"></td>
        </ng-container>

        <!-- Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumnsKeys"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsKeys;"></tr>
    </table>
</div>
